"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchingSuspense = void 0;
var react_1 = __importDefault(require("react"));
function hasOwnProperty(obj, prop) {
    return obj && obj.hasOwnProperty(prop);
}
var FetchingSuspense = function (props) {
    var status = props.itemFetchingStatus;
    if (props.fetchingSlowlyComponent && status.fetchingSlowlyDebounced) {
        return react_1.default.createElement(props.fetchingSlowlyComponent, __assign({}, props, { itemFetchingStatus: status }));
    }
    if (props.fetchingComponent && status.fetching) {
        return react_1.default.createElement(props.fetchingComponent, __assign({}, props));
    }
    if (status.fetched) {
        var empty = (hasOwnProperty(status, 'items') && hasOwnProperty(status.items, 'length') && !status.items.length) ||
            (hasOwnProperty(status, 'item') && hasOwnProperty(status.item, 'length') && !status.item.length) ||
            !status.item;
        if (empty && props.emptyComponent) {
            return (react_1.default.createElement(props.emptyComponent, __assign({}, props, { isList: (hasOwnProperty(status, 'item') && hasOwnProperty(status.item, 'length')) ||
                    (hasOwnProperty(status, 'items') && hasOwnProperty(status.items, 'length')) })));
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null, props.children);
        }
    }
    return null;
};
exports.FetchingSuspense = FetchingSuspense;
//# sourceMappingURL=FetchingSuspense.js.map